import React, { useEffect }     from 'react';
import PropTypes from 'prop-types';

import Note                 from '../../Favorite/Actor/Note';
import Pin                  from '../../Favorite/Actor/Pin';
import VideochatButton      from "../../SimpleElements/VideochatButton.js";
import TextchatButton       from '../../SimpleElements/TextchatButton';
import Translations         from "../../../utils/Translations.js";

const ActorProfileStickyHeader = ({actorData, isGuestLoggedIn}) => {

    const c2aButton = actorData.id !== 5613624 && (
        <div className='actor-profile-header__c2a clearfix -sticky'>
            <div className='actor-profile-header__c2a__videochat-btn-container'>
                {(actorData.isOnline || actorData.isOnlineMobileVideocall)
                    ? <VideochatButton
                        actorId                              = {actorData.id}
                        actorLink                            = {actorData.profileLink}
                        actorName                            = {actorData.name}
                        isActorNotAvailableForConversionChat = {!actorData.isAvailableForConversionChat}
                        isActorOnline                        = {actorData.isOnline}
                        isBannedCountryCode                  = {actorData.isBannedCountryCode}
                        isCurrentlyTicketShow                = {actorData.isCurrentlyTicketShow}
                        isLivePreviewEnabled                 = {actorData.isLivePreviewEnabled}
                        isLobbyChat                          = {actorData.isLobbyChat}
                        isOnlineMobileVideocall              = {actorData.isOnlineMobileVideocall}
                        isVoyeurChatAvailable                = {actorData.isVoyeurChatAvailable}
                        messagePrice                         = {actorData.prices?.message}
                        multiChatPrice                       = {actorData.prices?.video}
                        onlyVideochatButton                  = {true}
                        privateChatPrice                     = {actorData.prices?.single}
                        profileLink                          = {""}
                        serviceNumberItem                    = {{}}
                        singleC2CChatPrice                   = {actorData.prices?.singlec2c}
                        voucherChatMinutes                   = {actorData.prices?.voucherChatMinutes}
                        voyeurChatPrice                      = {actorData.prices?.voyeur}
                        isVoyeurMode                         = {false}
                        additionalClassNames                 = {'actor-profile-header__btn-videochat -sticky-header'}
                        buttonSubline                        = {null}
                        buttonText                           = {null}
                        useStandaloneIcon                    = {true}
                        freeChat                             = {actorData.freeShowData}
                        tooltipText                          = {Translations.get('TooltipVideoChatButton')}
                        cssModifier                          = {''}
                        useLoader                            = {true}
                        gaString                             = "Live-Chat_Model"
                    /> : <TextchatButton
                            actorId         = {actorData.id}
                            isGuestLoggedIn = {isGuestLoggedIn}
                            messagePrice    = {actorData.prices?.message}
                    />
                }
            </div>
        </div>
    );
    const actorText = actorData.showText ? actorData.showText.replace(/<br\s*\/?>/g, " - ") : "";
    return (
        <div className='js-actor-sticky-navigation container actor-profile-header-sticky'>
            <div  className='actor-profile-header__actor-info'>

                <div className='actor-profile-header__sticky-details'>

                    {/* Avatar  */}
                    <div className='actor-profile-header__actor-status'>
                        <span
                            className={'actor-status -size-xl ' + (actorData.isOnline ? 'is-online' : actorData.isOnlineMobileVideocall ? 'is-videocall' : 'is-offline')}
                            style={{
                                backgroundImage: `url(${actorData.previewPicture})`,
                                backgroundSize:  'cover'
                            }}
                        />
                    </div>

                    {/* Actor name, age and Favorite Pin */}
                    <div className='actor-profile-header__info-container -sticky'>
                        <div>
                            <p className='actor-profile-header__name h-left'>{actorData.name}</p>
                            <span className='actor-profile-header__age h-left'>({actorData.age})</span>
                            <span className='actor-profile-header__pin h-left'>
                                <Pin
                                    actorId                  = {actorData.id}
                                    initialIsFavoriteOfGuest = {actorData.isFavorite}
                                />
                            </span>
                            <div className="actor-profile-header__note h-left">
                                <Note
                                    actorId   = {actorData.id}
                                    autoClose = {true}
                                />
                            </div>
                        </div>
                        <span
                            dangerouslySetInnerHTML={{__html: actorText}}
                            className='actor-profile-header__text h-text-capitalize-first h-text-italic h-left'
                        />
                    </div>

                   {c2aButton}

                </div>
            </div>
        </div>
    )
}

ActorProfileStickyHeader.propTypes = {
    actorData:       PropTypes.object.isRequired,
    isGuestLoggedIn: PropTypes.bool.isRequired,
}

export default ActorProfileStickyHeader
